import {
  Bot, Briefcase, Building2, CalendarClock, Gauge, LayoutDashboard, Send, Settings, Sparkles, Trophy, UploadCloud, Users,
} from 'lucide-react'

// Two-sided recruitment market, grouped as the work actually flows:
//   ROLES (demand — the client's need)  →  DELIVERY (matching: screen → submit → interview → place)
//   →  TALENT (supply — our candidate inventory).
// Pages wired to the real backend have no badge; the rest are tagged "soon" (designed, not yet live).
export const atsNav = [
  {
    items: [
      { label: 'Dashboard', href: '/dashboard', icon: <LayoutDashboard className="h-5 w-5" /> },
      { label: 'Automation', href: '/automation', icon: <Bot className="h-5 w-5" /> },
    ],
  },
  {
    title: 'ROLES',
    items: [
      { label: 'Jobs', href: '/jobs', icon: <Briefcase className="h-5 w-5" /> },
      { label: 'Clients', href: '/clients', icon: <Building2 className="h-5 w-5" /> },
    ],
  },
  {
    title: 'DELIVERY',
    items: [
      { label: 'Live Screening', href: '/screen', icon: <Sparkles className="h-5 w-5" /> },
      { label: 'Submissions', href: '/pipeline', icon: <Send className="h-5 w-5" /> },
      { label: 'Interviews', href: '/interviews', icon: <CalendarClock className="h-5 w-5" /> },
      { label: 'Placements', href: '/placements', icon: <Trophy className="h-5 w-5" /> },
    ],
  },
  {
    title: 'TALENT',
    items: [
      { label: 'Candidates', href: '/candidates', icon: <Users className="h-5 w-5" /> },
      { label: 'Upload', href: '/upload', icon: <UploadCloud className="h-5 w-5" /> },
    ],
  },
  {
    title: 'ADMIN',
    items: [
      { label: 'AI Usage & Cost', href: '/ai-usage', icon: <Gauge className="h-5 w-5" /> },
      { label: 'Settings', href: '/settings', icon: <Settings className="h-5 w-5" />, badge: 'soon' },
    ],
  },
]
